var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepressed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Depressed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.446 22.8631C32.6453 22.8631 35.2389 20.2695 35.2389 17.0702C35.2389 14.473 33.5297 12.2752 31.1749 11.5398C31.3732 10.7889 31.4794 10.0005 31.4794 9.18739C31.4794 4.11332 27.366 0 22.292 0C18.9416 0 16.0106 1.79362 14.4055 4.47275C13.6978 4.16474 12.9172 3.99292 12.0962 3.99292C8.89682 3.99292 6.30324 6.58649 6.30324 9.78583C6.30324 10.1613 6.34025 10.5281 6.40852 10.8837C3.25945 11.0639 0.761108 13.6738 0.761108 16.868C0.761108 20.179 3.44519 22.8631 6.75618 22.8631H29.446Z",
    fill: "url(#paint0_linear_715_241)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.0179 5.00434C26.6422 4.57227 26.2139 4.18695 25.7449 3.85915C25.424 3.63476 25.3458 3.19265 25.5702 2.8718C25.7944 2.55089 26.2364 2.47258 26.5576 2.69697C27.1214 3.09117 27.6363 3.55437 28.088 4.07372C28.345 4.36925 28.3138 4.81702 28.0183 5.07404C27.721 5.33264 27.2733 5.29786 27.0179 5.00434Z",
    fill: "#C7C5CB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.7594 3.00727C23.5136 2.94904 23.2615 2.90508 23.0099 2.87661C22.6208 2.83258 22.341 2.48147 22.3851 2.09235C22.429 1.70324 22.7806 1.42313 23.1693 1.46752C23.477 1.5023 23.7855 1.55608 24.0863 1.62729C24.4674 1.71758 24.7031 2.0996 24.6128 2.48068C24.5228 2.86076 24.1415 3.09777 23.7594 3.00727Z",
    fill: "#C7C5CB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.1559 14.5091C11.9182 14.5091 12.5361 14.0125 12.5361 13.4C12.5361 12.7874 11.9182 12.2908 11.1559 12.2908C10.3937 12.2908 9.77576 12.7874 9.77576 13.4C9.77576 14.0125 10.3937 14.5091 11.1559 14.5091Z",
    fill: "#FD75BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.3983 14.5091C28.1605 14.5091 28.7784 14.0125 28.7784 13.4C28.7784 12.7874 28.1605 12.2908 27.3983 12.2908C26.636 12.2908 26.0181 12.7874 26.0181 13.4C26.0181 14.0125 26.636 14.5091 27.3983 14.5091Z",
    fill: "#FD75BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.5222 13.4001C15.0319 13.4001 16.2557 12.1763 16.2557 10.6666C16.2557 9.15702 15.0319 7.93323 13.5222 7.93323C12.0126 7.93323 10.7888 9.15702 10.7888 10.6666C10.7888 12.1763 12.0126 13.4001 13.5222 13.4001Z",
    fill: "#D6D5D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.7888 10.8004C10.8604 12.2481 12.0567 13.3999 13.5222 13.3999C14.9878 13.3999 16.1841 12.2481 16.2557 10.8004H10.7888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.8972 10.8004C11.967 11.6369 12.6676 12.2943 13.5222 12.2943C14.3768 12.2943 15.0774 11.6369 15.1473 10.8004H11.8972Z",
    fill: "#383842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.032 13.4001C26.5416 13.4001 27.7654 12.1763 27.7654 10.6666C27.7654 9.15702 26.5416 7.93323 25.032 7.93323C23.5224 7.93323 22.2986 9.15702 22.2986 10.6666C22.2986 12.1763 23.5224 13.4001 25.032 13.4001Z",
    fill: "#D6D5D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.2986 10.8004C22.3702 12.2481 23.5665 13.3999 25.032 13.3999C26.4975 13.3999 27.6939 12.2481 27.7654 10.8004H22.2986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.407 10.8004C23.4768 11.6369 24.1774 12.2943 25.032 12.2943C25.8866 12.2943 26.5872 11.6369 26.657 10.8004H23.407Z",
    fill: "#383842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.3281 13.5631C20.1973 13.5631 20.0662 13.5157 19.9626 13.4197C19.5526 13.0394 19.0015 13.0394 18.5915 13.4197C18.3736 13.6216 18.0334 13.6088 17.8313 13.391C17.6294 13.1732 17.6422 12.8329 17.86 12.6309C18.681 11.8696 19.8728 11.8696 20.694 12.6309C20.9117 12.8328 20.9247 13.1732 20.7226 13.391C20.6167 13.5053 20.4726 13.5631 20.3281 13.5631Z",
    fill: "#383842"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.7573 18.0336C10.5231 17.3153 9.75105 16.9221 9.03263 17.1561C7.81659 17.5522 6.59796 18.2035 5.55361 19.2478C4.72059 20.0808 4.16646 21.0847 3.89294 22.1363C4.74375 22.5998 5.71919 22.8632 6.75624 22.8632L10.3919 19.4564C10.7795 19.0932 10.9219 18.5386 10.7573 18.0336Z",
    fill: "#938EA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M22.7012 20.7196C22.6534 20.3756 22.4946 20.0566 22.249 19.8111C21.5626 19.1246 20.4225 19.2015 19.8439 19.981C19.1919 20.8593 18.8082 21.8349 18.6686 22.863H22.9995L22.7012 20.7196Z",
    fill: "#938EA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M12.787 18.7195C11.2188 18.7228 8.76845 19.0411 7.05773 20.7518C5.48155 22.328 5.39492 24.797 6.86439 26.2664C8.33379 27.7358 10.8028 27.6493 12.379 26.0731C14.0897 24.3624 14.408 21.9121 14.4113 20.3438C14.4133 19.4437 13.6872 18.7176 12.787 18.7195Z",
    fill: "url(#paint1_linear_715_241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M27.7051 18.7195C26.1369 18.7228 23.6865 19.0411 21.9758 20.7518C20.3996 22.328 20.313 24.797 21.7825 26.2664C23.2519 27.7358 25.7209 27.6493 27.2971 26.0731C29.0078 24.3624 29.3261 21.9121 29.3294 20.3438C29.3313 19.4437 28.6052 18.7176 27.7051 18.7195Z",
    fill: "url(#paint2_linear_715_241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M18.3813 27.4052C16.813 27.4085 14.3627 27.7268 12.652 29.4375C11.0758 31.0137 10.9892 33.4827 12.4586 34.9521C13.928 36.4215 16.397 36.3349 17.9732 34.7588C19.6839 33.048 20.0023 30.5978 20.0056 29.0295C20.0075 28.1294 19.2814 27.4033 18.3813 27.4052Z",
    fill: "url(#paint3_linear_715_241)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M16.2165 33.5753C15.9166 33.3233 15.8778 32.8761 16.1297 32.5763C16.2897 32.3859 16.4352 32.1645 16.5621 31.9183C16.7416 31.5702 17.1693 31.4338 17.5173 31.6132C17.8653 31.7928 18.0019 32.2204 17.8224 32.5684C17.6473 32.908 17.4431 33.2176 17.2154 33.4885C16.9633 33.7887 16.5159 33.8268 16.2165 33.5753Z",
    fill: "#DBEEF5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M17.7647 30.6332C17.3749 30.5947 17.0902 30.2477 17.1287 29.858C17.1401 29.7434 17.1491 29.6256 17.1557 29.5078C17.1774 29.1168 17.5128 28.8178 17.903 28.8392C18.2941 28.8609 18.5934 29.1956 18.5716 29.5865C18.5639 29.7244 18.5532 29.8626 18.54 29.9972C18.5015 30.3866 18.1546 30.672 17.7647 30.6332Z",
    fill: "#DBEEF5"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_241",
    x1: 18,
    y1: 22.8631,
    x2: 18,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223,
    stopColor: "#C1BFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D889D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_241",
    x1: 5.81659,
    y1: 23.0169,
    x2: 14.4114,
    y2: 23.0169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78C5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9788,
    stopColor: "#BBE3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_241",
    x1: 20.7346,
    y1: 23.0169,
    x2: 29.3294,
    y2: 23.0169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78C5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9788,
    stopColor: "#BBE3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_241",
    x1: 11.4108,
    y1: 31.7026,
    x2: 20.0057,
    y2: 31.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78C5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9788,
    stopColor: "#BBE3F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepressed);
export default __webpack_public_path__ + "static/media/Depressed.edae28a27bb6e0459ea0c31efd3aed70.svg";
export { ForwardRef as ReactComponent };